import { APIClient } from "../apiCore";
import * as url from "../urls";
import {m9sGlobals} from "../../config";
import {MainMetaType} from "../../redux/Main/common";
import {createPaginationQuery} from "../../helpers/functions";

const api = new APIClient();

const getSaleCurrencyRates = (data:MainMetaType) => {
    const query = createPaginationQuery(data);
    return api.get(m9sGlobals.CURRENT_CABINET+url.GET_SALE_CURRENCY_RATES+"?"+query);
};

const sendDataSaleCurrencyRate = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.UPDATE_SALE_CURRENCY_RATE, data);
};

const removeSaleCurrencyRate = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.REMOVE_SALE_CURRENCY_RATE, data);
};

export {
    getSaleCurrencyRates,
    sendDataSaleCurrencyRate,
    removeSaleCurrencyRate
};
